import {
  U21Chip,
  U21Modal,
  U21Spacer,
  U21Typography,
} from 'app/shared/u21-ui/components';

import { RiskModelSummary } from 'app/modules/riskRatings/responses';
import { useClearRiskScoreOverride } from 'app/modules/riskScore/queries/useClearRiskScoreOverride';
import { getRiskCategoryStyles } from 'app/modules/riskRatings/helpers';
import { IconAlertTriangle } from '@u21/tabler-icons';

interface Props {
  open: boolean;
  onClose: () => void;
  entityExternalId: string;
  modelScore: number;
  riskModelMetadata: Pick<
    RiskModelSummary,
    'high_risk_floor' | 'low_risk_ceiling'
  >;
}

export const ClearOverrideConfirmModal = ({
  open,
  onClose,
  entityExternalId,
  modelScore,
  riskModelMetadata,
}: Props) => {
  const { mutateAsync, isPending } =
    useClearRiskScoreOverride(entityExternalId);

  const riskStyles = getRiskCategoryStyles(
    modelScore,
    riskModelMetadata.high_risk_floor,
    riskModelMetadata.low_risk_ceiling,
  );

  return (
    <U21Modal
      open={open}
      onClose={onClose}
      title="Clear Override"
      actionButtonProps={{
        children: 'Clear Override',
        color: 'error',
        loading: isPending,
      }}
      onAction={async () => {
        try {
          await mutateAsync();
          onClose();
        } catch {}
      }}
    >
      <U21Spacer horizontal>
        <U21Typography variant="body2">
          This will restore the model-computed score of
        </U21Typography>
        <U21Chip
          variant="ghost"
          color={riskStyles.colorSchema}
          icon={<IconAlertTriangle />}
        >
          {riskStyles.label}: {Math.round(modelScore)}
        </U21Chip>
      </U21Spacer>
    </U21Modal>
  );
};
